import { useMemo } from 'react'
import {
  findNodeById,
  getParentNodeId,
  TreeNode
} from './treeModel'

export const useBreadcrumbsState = (
  treeData: TreeNode[],
  selectedNode: TreeNode | null
): TreeNode[] => (
  useMemo(() => (
    selectedNode
    ? selectedNodeToBreadcrumbs(treeData, selectedNode)
    : []
  ), [selectedNode])
)

const selectedNodeToBreadcrumbs = (
  treeData: TreeNode[],
  node: TreeNode | null
): TreeNode[] => {
  if (!node) return []

  if (node.type === 'file') return []

  const result: TreeNode[] = []
  let currentNode: TreeNode | null = node

  while (currentNode) {
    result.push(currentNode)
    const parentNodeId = getParentNodeId(currentNode)
    if (!parentNodeId) {
      currentNode = null
    } else {
      currentNode = findNodeById(treeData, parentNodeId)
    }
  }
  return result.reverse()
}
